import CheckMarkIcon from '@components/icons/CheckMarkIcon';

export const servicePlansEnum = {
  STANDARD: 'standard',
  PREMIUM: 'premium'
};

export const pageSourcesEnum = {
  STANDARD: 'standard'
};

export default {
  standard: {
    nameKey: 'landlord.landing.pricing-table.standard.name',
    descriptionKey: 'landlord.landing.pricing-table.standard.description',
    feeKey: 'landlord.landing.pricing-table.standard.fee',
    feeLabelKey: 'landlord.landing.pricing-table.fee.label',
    feeDescriptionKey:
      'landlord.landing.pricing-table.standard.fee-description',
    featureList: [
      {
        nameKey: 'landlord.landing.pricing-table.features.free-listing',
        icon: CheckMarkIcon,
        iconColour: '#880068'
      },
      {
        nameKey: 'landlord.landing.pricing-table.features.photos-and-videos',
        icon: CheckMarkIcon,
        iconColour: '#880068'
      },
      {
        nameKey: 'landlord.landing.pricing-table.features.no-calls',
        icon: CheckMarkIcon,
        iconColour: '#880068'
      },
      {
        nameKey: 'landlord.landing.pricing-table.features.reservations',
        icon: CheckMarkIcon,
        iconColour: '#880068'
      },
      {
        nameKey: 'landlord.landing.pricing-table.features.exit-protection',
        icon: CheckMarkIcon,
        iconColour: '#880068'
      }
    ],
    findOutMore: {
      isVisible: true,
      textKey: 'landlord.landing.pricing-table.features.find-out-more',
      url: 'landlord-standard'
    },
    cta: {
      textKey: 'landlord.landing.pricing-table.standard.sign-up',
      url: 'externals.landlord-signup',
      hasModal: false,
      leadType: 'standard'
    }
  },
  premium: {
    nameKey: 'landlord.landing.pricing-table.premium.name',
    descriptionKey: 'landlord.landing.pricing-table.premium.description',
    feeKey: 'landlord.landing.pricing-table.premium.fee',
    feeLabelKey: 'landlord.landing.pricing-table.fee.label',
    feeDescriptionKey: 'landlord.landing.pricing-table.premium.fee-description',
    featureList: [
      {
        nameKey: 'landlord.landing.pricing-table.features.free-listing',
        icon: CheckMarkIcon,
        iconColour: '#880068'
      },
      {
        nameKey: 'landlord.landing.pricing-table.features.photos-and-videos',
        icon: CheckMarkIcon,
        iconColour: '#880068'
      },
      {
        nameKey: 'landlord.landing.pricing-table.features.no-calls',
        icon: CheckMarkIcon,
        iconColour: '#880068'
      },
      {
        nameKey: 'landlord.landing.pricing-table.features.reservations',
        icon: CheckMarkIcon,
        iconColour: '#880068'
      },
      {
        nameKey: 'landlord.landing.pricing-table.features.damage-protection',
        icon: CheckMarkIcon,
        iconColour: '#880068'
      },
      {
        nameKey: 'landlord.landing.pricing-table.features.pay-for-unpaid-rent',
        icon: CheckMarkIcon,
        iconColour: '#880068'
      },
      {
        nameKey: 'landlord.landing.pricing-table.features.write-contracts',
        icon: CheckMarkIcon,
        iconColour: '#880068'
      }
    ],
    findOutMore: {
      isVisible: false,
      textKey: 'landlord.landing.pricing-table.features.find-out-more',
      url: 'landlord-premium'
    },
    cta: {
      textKey: 'landlord.landing.pricing-table.premium.sign-up',
      url: '',
      hasModal: true,
      leadType: 'premium'
    }
  }
};
